@let _options = options();
@if (_options?.download?.['dynamicUrl'] || _options?.download?.['url']) {
  <button
    mat-icon-button
    tooltip-position="below"
    matTooltipShowDelay="500"
    [matTooltip]="'igo.geo.download.action' | translate"
    [color]="color()"
    (click)="openDownload()"
  >
    <mat-icon>download</mat-icon>
  </button>
}
